function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
module.exports = _forceReduced;


//////////////////
// WEBPACK FOOTER
// ../~/ramda/src/internal/_forceReduced.js
// module id = 675
// module chunks = 0